<div class="wizard-step">
    <h2 class="step-title">Paso 3: Multimedia</h2>

    <div class="section">
        <h3 class="section-title">Imagen de Portada</h3>
        <p class="section-description">
            Esta es la imagen principal de tu producto o servicio. Relación de aspecto 16:9.
            Tamaño sugerido ≥1600×900px.
        </p>

        <div class="upload-area" (click)="!isReadonly && triggerCoverInput()"
            [class.has-image]="coverPreview || coverFileId" [class.disabled]="isReadonly">
            <input id="coverFileInput" type="file" accept="image/png, image/jpeg, image/webp"
                (change)="onCoverImageSelect($event)" style="display:none" [disabled]="isReadonly" />

            <div class="upload-content" *ngIf="!coverPreview && !coverFileId">
                <svg class="upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7,10 12,15 17,10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <p class="upload-text">Haz clic para subir o arrastra y suelta</p>
                <p class="upload-formats">PNG, JPG o WEBP (MÁX. {{ MAX_FILE_SIZE / (1024 * 1024) }}MB)</p>
            </div>

            @if(coverFileId){
            <img [src]="fileBaseUrl + '/' + coverFileId" alt="Imagen de portada" class="cover-preview" />
            } @else {
            <img *ngIf="coverPreview" [src]="coverPreview" alt="Imagen de portada" class="cover-preview" />
            }
        </div>

        @if(!coverPreview && !coverFileId && !isReadonly){
        <div class="invalid-field">
            Debes seleccionar una imagen de portada antes de continuar.
        </div>
        }
    </div>

    <div class="section">
        <h3 class="section-title">Galería</h3>

        <input id="galleryFileInput" type="file" [accept]="GALLERY_ACCEPT" (change)="onGalleryFileSelected($event)"
            style="display:none" [disabled]="isReadonly" />

        <div class="gallery-grid">
            <div class="gallery-card" *ngFor="let item of galleryItems; let i = index">
                <div class="media-badge" [ngClass]="{
          'badge-image': (item.mediaType | uppercase) ==='IMAGE',
          'badge-video': (item.mediaType | uppercase) ==='VIDEO',
          'badge-pdf': (item.mediaType | uppercase) ==='PDF'
        }">
                    {{ (item.mediaType | uppercase) === 'IMAGE' ? 'Imagen' :
                    (item.mediaType | uppercase) === 'VIDEO' ? 'Video' : 'PDF' }}
                </div>

                <div class="gallery-preview">
                    <ng-container *ngIf="(item.mediaType | uppercase) ==='IMAGE'">
                        @if(item?.id && item.fileId){
                        <img class="thumb" [src]="fileBaseUrl +'/'+item.fileId" alt="Imagen" />
                        }@else{
                        <img class="thumb" [src]="item.filePreview || item.fileBase64" alt="Imagen" />
                        }
                    </ng-container>

                    <ng-container *ngIf="(item.mediaType | uppercase) ==='VIDEO'">
                        <div class="video-wrap">
                            <video #vid class="thumb"
                                [src]="(item?.id && item.fileId) ? fileBaseUrl +'/'+item.fileId : item.filePreview || item.fileBase64"
                                preload="metadata" muted playsinline (play)="hideOverlay(overlay)"
                                (pause)="showOverlay(overlay)" (ended)="showOverlay(overlay)">
                            </video>
                            <button #overlay class="play-overlay" type="button"
                                (click)="playVideo(vid, overlay, $event)">▶</button>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="(item.mediaType | uppercase) ==='PDF'">
                        <button type="button" class="pdf-tile" (click)="openPdf(item)">
                            <span class="pdf-mark">PDF</span>
                        </button>
                    </ng-container>
                </div>

                @if(!isReadonly){
                <input type="text" class="gallery-input" placeholder="Descripción (caption)" [(ngModel)]="item.caption"
                    (ngModelChange)="onCaptionChange()" />
                } @else if(item.caption) {
                <p class="form-control-plaintext mb-0">{{ item.caption }}</p>
                }

                <div class="meta" [ngClass]="{'mb-1': isReadonly}">
                    <span class="name">{{ item.fileName }}</span>
                    <span class="type">{{ item.contentType }}</span>
                </div>

                @if(!isReadonly){
                <div class="row-actions">
                    <div class="left">
                        <button class="btn-ghost" (click)="moveUp(i)" [disabled]="i===0">▲</button>
                        <button class="btn-ghost" (click)="moveDown(i)"
                            [disabled]="i===galleryItems.length-1">▼</button>
                    </div>
                    <div class="right">
                        <button class="btn-danger" (click)="removeItem(i)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                </div>
                }
            </div>

            @if(!isReadonly){
            <div class="gallery-card add-card" (click)="triggerGalleryInput()">
                <div class="add-box">
                    <div class="add-plus">＋</div>
                    <div class="add-title">Añadir archivo</div>
                    <div class="add-sub">Imagen, Video o PDF</div>
                    <div class="add-allow">Permitidos: PNG, JPG, WEBP, MP4, WEBM, OGG, PDF</div>
                </div>
            </div>
            }
        </div>
    </div>
</div>

<div portalToBody class="modal fade" id="pdfModal" tabindex="-1" aria-labelledby="pdfModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 id="pdfModalLabel" class="modal-title">{{ pdfPreviewName }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body p-0">
                <embed class="pdf-embed-fixed" [attr.src]="pdfPreviewSafe" type="application/pdf" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>